import '../product-list/script/index.js';
import '../features/find-in-store/scripts/index.js';
import '../features/search-color-rewrite/scripts/index.js';
